import { getCookie } from "src/utils/browserHelpers";
import { isUserSignedIn } from "src/utils/generalUtils";
// import { sendToGTM } from "./gtmGA";
import Clevertap from "./index";
// import { sendToGTM } from "./gtmGA";
import { ravenCommonPayload, triggerRaven } from "./triggerRaven";
// import { getMartechUserData } from "./martech";
import { sendEventWithUserInsights } from "@cleartrip/ct-platform-utils";

export const sendBusUIAction = (
  actionDetails: Record<string, string | boolean | number> = {},
  ravenEventName?: string
) => {
  const eventNameUIAction = "BUS_UI_Action";
  Clevertap.event(eventNameUIAction, actionDetails);
  // sendToGTM(actionDetails, eventNameUIAction);
  if (ravenEventName) {
    triggerRaven(ravenEventName, actionDetails);
  }
};

export const sendBusPageLoad = async (
  eventName: string,
  actionDetails: Record<string, string | boolean | number> = {},
  ravenEventName?: string
) => {
  Clevertap.event(eventName, actionDetails);
  if (ravenEventName) {
    if (ravenEventName) {
      const ravenPayload = {
        ...actionDetails,
        ...ravenCommonPayload,
      };
      sendEventWithUserInsights(ravenEventName, ravenPayload);
    }
  }
};

export const sendBusCustomEvent = (
  pageName: string,
  actionDetails: Record<string, string | boolean | number> = {},
  ravenEventName?: string
) => {
  Clevertap.event(pageName, actionDetails);
  if (ravenEventName) {
    triggerRaven(ravenEventName, actionDetails);
  }
};

export const triggerHiFiveClevertap = (
  payload = {},
  eventName = "BUS_UI_Action"
) => {
  const commonParams: Record<string, string> = {};
  const isSignedIn = isUserSignedIn();
  if (isSignedIn) {
    const userIdCookie = getCookie("userid");
    const userId = decodeURIComponent(userIdCookie).split("|")[4];
    commonParams["user_id"] = userId;
  }
  Clevertap.event(eventName, {
    ...payload,
    ...commonParams,
  });
};

export const sendClevertapUIActionEvent = ({
  actionName = "",
  actionType = "BUTTON",
  page = "",
  ...additionalData
}) => {
  const fullPayload = {
    action_name: actionName,
    action_type: actionType,
    source: "web",
    domain: window.location.host,
    source_page_name: page,
    ...additionalData,
  };

  Clevertap.event("BUS_UI_Action", fullPayload);
};

export const ACTION_NAMES = {
  loginError: "Error_Occured_Login_modal",
  loginSuccess: "Login_succesful",
  otpFetched: "Get_OTP_entered_on_login modal",
  mobileEntered: "Mobile_number_entered_on_login_modal",
  invalidValue: "Invalid_value_entered",
  loginOpened: "Login_Signup_modal_opened",
  otpOpened: "login_OTP_modal_opened",
  otpEntered: "Entered_OTP_on_login_modal",
};

export const ACTION_ERRORS = {
  otpGenerationFailed: "OTP generation failed",
  otpVerificationFailed: "OTP verification failed",
  otpLimit: "OTP limit exceeded",
};
